
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 0a12 12 0 1012 12A12 12 0 0012 0zm3.75 15.06h-1.41v2.53h-1.9v-2.53H7.53l-.06-1.16 4.9-7.69h1.97v7.32h1.41z"}}),_c('path',{attrs:{"d":"M9.46 13.53h2.98V8.78l-.14.25-2.84 4.5z"}})])
          )
        }
      }
    